document.addEventListener("DOMContentLoaded", async () => {
  const jsonUrl = "https://cdn.shopify.com/s/files/1/0780/7539/6411/files/plaster_mix_instructions.json?v=1738019965";

  try {
    const response = await fetch(jsonUrl);
    const data = await response.json();

    // Populate the dropdown with plaster options
    const plasterTypeDropdown = document.getElementById("plasterType");
    data.plasters.forEach(plaster => {
      const option = document.createElement("option");
      option.value = plaster.id;
      option.textContent = plaster.name;
      plasterTypeDropdown.appendChild(option);
    });

    // Handle dropdown selection change
    plasterTypeDropdown.addEventListener("change", () => {
      updateRatio(data);
      updateInstructions(data);
      updatePdfViewer(data);
    });

    // Show slider with set values or hide it if min and max are the same
    function updateRatio(data) {
      const selectedPlaster = data.plasters.find(plaster => plaster.id === plasterTypeDropdown.value);
      const ratioSliderContainer = document.getElementById("ratioSliderContainer");
      const ratioSlider = document.getElementById("ratioSlider");
      const ratioValueDisplay = document.getElementById("ratioValue");

      if (selectedPlaster) {
        if (selectedPlaster.ratioRange.min === selectedPlaster.ratioRange.max) {
          // Hide slider if min and max are the same
          ratioSliderContainer.style.display = "none";
          ratioValueDisplay.textContent = `${selectedPlaster.ratioRange.min} (Fixed)`;
        } else {
          // Show slider and populate with set steps
          ratioSliderContainer.style.display = "block";
          ratioSlider.min = selectedPlaster.ratioRange.min;
          ratioSlider.max = selectedPlaster.ratioRange.max;
          ratioSlider.step = 1; // Adjust step size as needed
          ratioSlider.value = selectedPlaster.ratioRange.min; // Default to min value
          ratioValueDisplay.textContent = ratioSlider.value;

          // Update displayed value when slider is moved
          ratioSlider.addEventListener("input", () => {
            ratioValueDisplay.textContent = ratioSlider.value;
          });
        }
      } else {
        ratioSliderContainer.style.display = "none";
        ratioValueDisplay.textContent = "N/A";
      }
    }

    // Update instructions dynamically
    function updateInstructions(data) {
      const selectedPlaster = data.plasters.find(plaster => plaster.id === plasterTypeDropdown.value);
      const instructionsContainer = document.getElementById("instructions");

      if (selectedPlaster && selectedPlaster.instructions) {
        instructionsContainer.style.display = "block";
        instructionsContainer.innerHTML = `<h3>Instructions:</h3><p>${selectedPlaster.instructions}</p>`;
      } else {
        instructionsContainer.style.display = "none";
      }
    }

    // Update PDF viewer dynamically
    function updatePdfViewer(data) {
      const selectedPlaster = data.plasters.find(plaster => plaster.id === plasterTypeDropdown.value);
      const pdfViewerContainer = document.getElementById("pdfViewer");
      const pdfFrame = document.getElementById("pdfFrame");

      if (selectedPlaster && selectedPlaster.pdfUrl) {
        pdfViewerContainer.style.display = "block";
        pdfFrame.src = selectedPlaster.pdfUrl;
      } else {
        pdfViewerContainer.style.display = "none";
        pdfFrame.src = ""; // Clear the iframe
      }
    }

    // Full Screen Functionality
    const toggleFullScreenBtn = document.getElementById("toggleFullScreen");
    toggleFullScreenBtn.addEventListener("click", () => {
      const pdfFrame = document.getElementById("pdfFrame");
      if (pdfFrame.requestFullscreen) {
        pdfFrame.requestFullscreen();
      } else if (pdfFrame.mozRequestFullScreen) {
        pdfFrame.mozRequestFullScreen(); // Firefox
      } else if (pdfFrame.webkitRequestFullscreen) {
        pdfFrame.webkitRequestFullscreen(); // Chrome, Safari, and Opera
      } else if (pdfFrame.msRequestFullscreen) {
        pdfFrame.msRequestFullscreen(); // IE/Edge
      }
    });

    // Handle form submission for manual calculation
    const form = document.getElementById("plasterEstimatorForm");
    form.addEventListener("submit", function(event) {
      event.preventDefault(); // Prevent default form submission
      calculateMix(data); // Perform the calculation manually
    });

    // Perform calculations
    function calculateMix(data) {
      const selectedPlaster = data.plasters.find(plaster => plaster.id === plasterTypeDropdown.value);
      if (!selectedPlaster) return;

      const totalWeight = parseFloat(document.getElementById("totalWeight").value) || 0;
      const ratio = parseFloat(document.getElementById("ratioSlider").value) || 0;

      const water = (selectedPlaster.ratioType === "water-to-plaster")
        ? (totalWeight * ratio) / 100
        : (totalWeight / ratio) * 100;
      const plaster = totalWeight - water;

      document.getElementById("waterRequired").textContent = water.toFixed(2);
      document.getElementById("plasterRequired").textContent = plaster.toFixed(2);
    }
  } catch (error) {
    console.error("Error fetching plaster data:", error);
  }
});
